<template>
  <div class="content">
    <CCol ref="content" xs="12" lg="12">
      <CCard>
        <!-- <CCardHeader>User Data</CCardHeader> -->
        <CCardBody>
          <v-card
            style="padding-top: 20px; padding-left: 20px; padding-right: 20px; padding-bottom: 30px;"
            shaped
          >
            <v-row>
              <div class="col-md-4 col-xl-6">
             <edit-profile-form  />  
              </div>
              <div class="col-md-6 col-xl-6 col-sm-12">
                <add-Admin />
              </div>
            </v-row>
          </v-card>
        </CCardBody>
      </CCard>
    </CCol>
  </div>
</template>

<script>
import { EditProfileForm, UserCard } from "@/pages";
import addAdmin from "./UserProfile/Add_admin";
import router from "@/routes";
export default {
  components: {
    EditProfileForm,
    "add-Admin": addAdmin
    // UserCard
  },
  created() {
    /*  if(this.$store.state.Auth == false)
        router.push('/login')*/
  }
};
</script>
